import Flag from '@mui/icons-material/Flag';
import HollowHeart from '@mui/icons-material/FavoriteBorder';
import Heart from '@mui/icons-material/Favorite';
import Share from '@mui/icons-material/Send';
import Smiley from '@mui/icons-material/SentimentSatisfiedAlt';
import Settings from '@mui/icons-material/Settings';
import Message from '@mui/icons-material/Message';
import EditNote from '@mui/icons-material/EditNote';
import RemoveCircle from '@mui/icons-material/RemoveCircle';
import Article from '@mui/icons-material/Article';
import Thumbs from '@mui/icons-material/ThumbUpAlt';
import Menu from '@mui/icons-material/Menu';
import MenuOpen from '@mui/icons-material/MenuOpen';
import Profile from '@mui/icons-material/PersonOutline';
import CheckCircle from '@mui/icons-material/CheckCircleOutline';
import EastArrow from '@mui/icons-material/East';
import Download from '@mui/icons-material/FileDownload';
import Org from '@mui/icons-material/Groups2';
import UpArrow from '@mui/icons-material/ArrowUpward';
import DownArrow from '@mui/icons-material/ArrowDownward';
import Focus from '@mui/icons-material/Pages';
import Minimise from '@mui/icons-material/Minimize';
import Close from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import OpenInNew from '@mui/icons-material/OpenInNew';
import DottedCrossHairs from '@mui/icons-material/GpsFixed';
import CrossHairs from '@mui/icons-material/GpsNotFixed';
import Completed from '@mui/icons-material/TaskAlt';
import TriDots from '@mui/icons-material/MoreVert';

export {
    Flag,
    HollowHeart,
    Heart,
    Share,
    Smiley,
    Settings,
    Message,
    EditNote,
    RemoveCircle,
    Article,
    Thumbs,
    Menu,
    MenuOpen,
    Profile,
    CheckCircle,
    EastArrow,
    Download,
    Org,
    UpArrow,
    DownArrow,
    Focus,
    Minimise,
    Close,
    Visibility,
    OpenInNew,
    CrossHairs,
    DottedCrossHairs,
    Completed,
    TriDots,
};